export default function AppLoader(props: {
  className?: string
}) {
  const { className } = props
  return (
    <div className={`app-loading ${className}`}>
      <div className="loader"></div>
    </div>
  )
}